/*
* Created on Mar 18, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, { createContext, useContext, useState } from 'react';
import {convert_error_code} from "../service/common";
import {useTranslation} from "react-i18next";

const AlertContext = createContext(null);
export const useAlertContext = () => useContext(AlertContext);

export const AlertProvider = ({children}) => {
    const [showAlert, setShowAlert] = useState(false);
    // alert-info / alert-error / alert-success / alert-warning
    const [showAlertType, setShowAlertType] = useState('info');
    const [message, setMessage] = useState('');
    const {t} = useTranslation();

    const alert = (show, type, code, message, auto_hide=0) => {
        setShowAlert(show);
        setShowAlertType(type);
        if ( type === 'error') {
            setMessage(convert_error_code(code, message))
        }
        else {
            setMessage(message);
        }
        if (auto_hide > 0) {
            window.setTimeout(()=>{
                setShowAlert(false);
            }, auto_hide);
        }
    }

    return (
        <AlertContext.Provider value={alert}>
            <div className={`fixed-alert alert-${showAlertType} ${showAlert ? '' : 'hide'}`}>
                <div className="alert-content">
                    <button type="button" className="alert-close-btn" aria-hidden="true" onClick={()=>setShowAlert(false)}>×</button>
                    <div className="alert-msg">
                        {t(message)}
                    </div>
                </div>
            </div>
            {children}
        </AlertContext.Provider>
    );
};
